
import { defineComponent } from '@nuxtjs/composition-api'

const validTargets = ['active', 'available', 'unavailable', 'neutral', 'results']

export default defineComponent({
  props: {
    /**
     * We have various states:
     *
     * active
     * available (1)
     * available mobile (2)
     * unavailable
     * neutral
     * results
     *
     * This button is exclusively used for filters
     */
    state: { type: String, required: false, default: 'available', validator: (value) => validTargets.includes(value) },
    mobile: { type: Boolean, required: false, default: false },
  },
})
